import { useEffect, useState } from 'react'
import { useApp } from '@/app/AppContext'
import { ApiError } from '@/lib/api'
import { fetchRecording } from './api'

/**
 * Проигрыватель записи разговора в ленте (тикет #122).
 *
 * Запись загружается по нажатию, а не при открытии ленты: каждое прослушивание — запрос к АТС
 * (у Mango ссылка на файл одноразовая), и лента из двадцати звонков иначе скачивала бы двадцать
 * записей, которые никто не слушал. Байты идут через наш сервер с токеном в заголовке, поэтому
 * `<audio src>` на адрес API не годится — браузер не поставит `Authorization`; проигрывается
 * объект `Blob`.
 */
export function RecordingPlayer({ path }: { path: string }) {
  const { t } = useApp()
  const [url, setUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => () => {
    if (url && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url)
  }, [url])

  if (url) {
    return <audio controls autoPlay src={url} aria-label={t('telephony.recording')} style={{ maxWidth: '100%' }} />
  }
  return (
    <span className="row" style={{ gap: 6 }}>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        disabled={loading}
        onClick={() => {
          setLoading(true)
          setError(null)
          fetchRecording(path)
            .then((blob) => setUrl(URL.createObjectURL(blob)))
            .catch((failure: unknown) => setError(failure instanceof ApiError ? failure.message : t('app.error')))
            .finally(() => setLoading(false))
        }}
      >
        {loading ? t('telephony.recording.loading') : t('telephony.recording.play')}
      </button>
      {error && <span className="t-sm" role="alert">{error}</span>}
    </span>
  )
}

/** «1 мин 23 с» — длительность звонка словами. */
export function formatDuration(seconds: number, t: (key: string, params?: Record<string, string | number>) => string): string {
  const total = Math.max(0, Math.round(seconds))
  const minutes = Math.floor(total / 60)
  const rest = total % 60
  return minutes > 0
    ? t('telephony.duration.minutes', { minutes, seconds: rest })
    : t('telephony.duration.seconds', { seconds: rest })
}
